import { render, staticRenderFns } from "./projectmanagement.vue?vue&type=template&id=17928c56&"
import script from "./projectmanagement.vue?vue&type=script&lang=js&"
export * from "./projectmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports